import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth
  },
  state: {
    loading: true,
    config: null,
    user: {
      name: '',
      currentSeason: {}
    }
  },
  mutations: {
    loading (state) {
      state.loading = true
    },
    loaded (state) {
      state.loading = false
    },
    currentUser (state, user) {
      state.user.name = user.name
      state.user.currentSeason = user.currentSeason
      state.config = user.config
    }
  },
  getters: {
    loading: state => state.loading
  },
  actions: {
  }
})
